import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import UserAvatar from '@ui/components/user-avatar/UserAvatar';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import ReviewStar from '@ui/icons/star-gold.svg';
import theme from '@ui/theme';
import Image from 'next/image';
import React, { useEffect ,useState } from 'react';
import { A11y, Mousewheel, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import useStyles from './Testimonials.style';
import { denverTestimonials, testimonials, TestimonialsType } from './TestimonialsData';

interface TestimonialAltProps {
  backgroundColor?: string;
  location?: 'denver' | 'san-diego';
  testimonialsShown?: number;
}

export const Testimonials: React.FC<TestimonialAltProps> = (props) => {
  const { backgroundColor, location, testimonialsShown = 4 } = props;
  const { classes, theme } = useStyles();
  const { sm, md } = useBreakpoints();
  const [selectedTestimonials, setSelectedTestimonials] = useState<TestimonialsType>(testimonials);

  useEffect(() => {
    if (location === 'denver') {
      setSelectedTestimonials(denverTestimonials);
    }
  }, []);

  return (
    <>
      {md ?
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="stretch"
          gap={2}
        >
          {selectedTestimonials.slice(0, testimonialsShown).map((item, i) => {
            const { quote, user } = item;

            return (
              <Box
                key={i}
                display="flex"
                flex={1}
              >
                <Box
                  display="flex"
                  alignItems="flex-start"
                  flexDirection="column"
                  className={classes.agentCard}
                  style={{ margin: 0, backgroundColor: backgroundColor, textAlign: 'left' }}
                >
                  <UserAvatar
                    size={sm ? 100 : 135 }
                    user={{
                      photoURL: user.photoURL,
                      firstname: user.firstname,
                      lastname: user.lastname,
                    }}
                    className={classes.quoteAvatar}
                  />

                  <Typography
                    variant="h5Alt"
                    className={classes.quoteTitle1}
                  >
                    {user.firstname}
                    {' '}
                    {user.lastname}
                  </Typography>

                  <Typography
                    className={classes.quoteTitle2}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    {user.brandLogoURL && (
                    <Image
                      src={user.brandLogoURL}
                      alt={user.title}
                      width={24}
                      height={24}
                      style={{ marginRight: theme.spacing(1), borderRadius: '100%' }}
                    />
                    )}
                    {user.title}
                  </Typography>

                  <Grid
                    container
                    justifyContent="flex-start"
                    spacing={1}
                    style={{ position: 'relative', top: theme.spacing(2), marginBottom: theme.spacing(2) }}
                  >
                    <Grid item>
                      <ReviewStar
                        className={classes.reviewStar}
                      />
                    </Grid>
                    <Grid item>
                      <ReviewStar className={classes.reviewStar} />
                    </Grid>
                    <Grid item>
                      <ReviewStar className={classes.reviewStar} />
                    </Grid>
                    <Grid item>
                      <ReviewStar className={classes.reviewStar} />
                    </Grid>
                    <Grid item>
                      <ReviewStar className={classes.reviewStar} />
                    </Grid>

                  </Grid>
                  <Typography className={classes.quoteText}>
                    {quote}
                  </Typography>

                </Box>
              </Box>
            );
          })}
        </Box>
        :
        <Swiper
          navigation
          className={classes.swiper}
          modules={[Pagination, Navigation, A11y, Mousewheel]}
          observer={true}
          observeParents={true}
          slidesPerView="auto"
          mousewheel={{
            forceToAxis: true,
          }}
          spaceBetween={24}
          threshold={md ? 250 : 0}
        >
          {testimonials.map((item, i) => {
            const { quote, user } = item;

            return (
              <SwiperSlide
                key={i}
                style={{ width: 'auto' }}
              >
                <Box
                  key={i}
                  display="flex"
                  alignItems="flex-start"
                  flexDirection="column"
                  className={classes.agentCard}
                  style={{ width: 250, backgroundColor: props.backgroundColor }}
                >
                  <UserAvatar
                    size={100}
                    user={{
                      brandLogoURL: user.brandLogoURL,
                      photoURL: user.photoURL,
                      firstname: user.firstname,
                      lastname: user.lastname,
                    }}
                    className={classes.quoteAvatar}
                  />

                  <Typography
                    variant="h5Alt"
                    className={classes.quoteTitle1}
                  >
                    {user.firstname}
                    {' '}
                    {user.lastname}
                  </Typography>

                  <Typography className={classes.quoteTitle2}>
                    {user.title}
                  </Typography>

                  <Grid
                    container
                    justifyContent="flex-start"
                    spacing={1}
                   
                  >
                    <Grid item>
                      <ReviewStar style={{ height: 16, width: 16 }} />
                    </Grid>
                    <Grid item>
                      <ReviewStar style={{ height: 16, width: 16 }} />
                    </Grid>
                    <Grid item>
                      <ReviewStar style={{ height: 16, width: 16 }} />
                    </Grid>
                    <Grid item>
                      <ReviewStar style={{ height: 16, width: 16 }} />
                    </Grid>
                    <Grid item>
                      <ReviewStar style={{ height: 16, width: 16 }} />
                    </Grid>

                  </Grid>

                  <Typography className={classes.quoteText}>
                    {quote}
                  </Typography>

                  
                </Box>
              </SwiperSlide>
            );
          })}
        </Swiper>
      }
    </>
  );
};

Testimonials.defaultProps = {
  backgroundColor: theme.palette.pink.main
};

export default Testimonials;
